module.exports = __webpack_public_path__ + "static/Finastra-1bdd200014b9a754871a14492af278b7.png";